import { SVGProps } from "react";
import styles from "../variants/01/sw-categories-variant-01.module.scss";

export const CategorySedanSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 837.2 271.5"
    style={{
      // @ts-ignore
      enableBackground: "new 0 0 837.2 271.5",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path
      className={styles.st0}
      d="M225.3 91c-15.9-.7-28.5-1.2-36.4-1.6 0 0-16.6-14.1-16.6-26.8 0-6.3 17.3-17.4 48.4-26.8 1 15.2 3.6 43.8 4.6 55.2zM159.3 168.7c23.1 0 41.9 18.8 41.9 41.9s-18.8 41.9-41.9 41.9-41.9-18.8-41.9-41.9 18.8-41.9 41.9-41.9m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9-27.3-60.9-60.9-60.9zM701 168.7c23.1 0 41.9 18.8 41.9 41.9S724 252.5 701 252.5s-41.9-18.8-41.9-41.9 18.8-41.9 41.9-41.9m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9-27.3-60.9-60.9-60.9z"
    />
    <path
      className={styles.st0}
      d="M834.7 166.2c-6.5 0-6.9-3.3-6.9-3.7v-.3l-.1-.3c-3.7-16.2-17.6-48.1-43.8-52.4-22.5-3.7-171.4-29.1-179.9-30.6-5.7-2.9-82.2-41.2-126.8-61.5C432.3-2.9 354-.7 291.1 1.1l-9.5.3c-59 1.6-94.2 20.8-111.2 30.1-1.8 1-3.3 1.8-4.8 2.6-2.4 1.3-5.3 2.9-8.7 4.8-18.7 10.6-50.1 28.3-87.6 33.5-45.8 6.4-56.2 28.7-56.6 29.7l-.2.4L7.1 170c-2.2.4-3.6 1.5-4.5 2.4C0 175.2 0 179 0 179.7V204c0 6.3 2.4 12 7.2 16.7 18 17.8 64 18.1 68.9 18.1h.3l5.1.2c-.6-1.7-1.2-3.4-1.7-5.1-2.2-7.4-3.4-15.3-3.4-23.4 0-45.6 37.1-82.8 82.8-82.8 45.6 0 82.8 37.1 82.8 82.8 0 10.7-2 21-5.8 30.3-.7 1.7-1.4 3.3-2.1 4.9l4.5.2H623l1-.1c-.8-1.6-1.5-3.3-2.2-4.9-3.7-9.4-5.8-19.7-5.8-30.5 0-45.6 37.1-82.8 82.8-82.8 45.6 0 82.8 37.1 82.8 82.8 0 7.5-1 14.8-2.9 21.8-.5 1.7-1 3.4-1.6 5.1l5.4-.3h28c19.2 0 25.7-19.7 26.5-30.2v-40.7h-2.3zm-2.5 40.5c-.2 1.9-2.6 25.4-21.5 25.4h-26.5c1.7-6.9 2.7-14.1 2.7-21.5 0-48.4-39.4-87.8-87.8-87.8s-87.8 39.4-87.8 87.8c0 10.7 1.9 21 5.5 30.5H241.6c3.5-9.5 5.5-19.8 5.5-30.5 0-48.4-39.4-87.8-87.8-87.8s-87.8 39.4-87.8 87.8c0 8 1.1 15.8 3.1 23.2-9-.2-48.7-1.6-63.9-16.7C6.9 213.3 5 209 5 204v-24.5s0-2.2 1.2-3.6c.7-.8 1.8-1.1 3.2-1.1h2.3l5.7-71.1C19 101 30.3 82.9 70 77.3c38.4-5.3 71.5-24.1 89.3-34.1 3.3-1.9 6.2-3.5 8.6-4.8 1.4-.8 3-1.6 4.8-2.6 16.6-9.1 51.1-27.9 108.9-29.5l9.5-.3c62.4-1.8 140.1-3.9 184 16 46.1 21 126.1 61.2 127 61.6l.3.2.4.1c1.6.3 157.2 26.9 180.3 30.6 21.8 3.6 35.6 30.8 39.7 48.3.2 2.8 2.3 7.3 9.4 8.2v35.7z"
    />
    <path
      className={styles.st0}
      d="M334.6 18.7c7.7 15.4 13.1 58.3 15.1 77.3-41-1.7-82.2-3.3-113.7-4.7l-6-58.4c27-7.1 62.4-13 104.6-14.2zM546.5 75.6s-45.6-2.5-30 27.1c0 0-67.2-2.7-141.6-5.7-3.5-45.8-11.2-70.3-14.2-78.4 104.8 3.2 185.8 57 185.8 57z"
    />
    <path
      className={styles.st0}
      d="M334.6 18.7C292.4 19.9 257 25.8 230 33.1l6 58.4c31.5 1.3 72.7 3 113.7 4.7-2-19.2-7.4-62.1-15.1-77.5"
    />
  </svg>
);
